// Reuse the existing reader; focus/visibility may arrive together, so coalesce them.
export function subscribeTaskRefresh(refresh:()=>void) {
  let disposed=false,queued=false;
  const request=()=>{
    if(document.visibilityState!=='visible'||queued)return;
    queued=true;
    Promise.resolve().then(()=>{queued=false;if(!disposed&&document.visibilityState==='visible')refresh();});
  };
  window.addEventListener('focus',request);
  document.addEventListener('visibilitychange',request);
  return ()=>{disposed=true;window.removeEventListener('focus',request);document.removeEventListener('visibilitychange',request);};
}
